import { memo } from "react"
import { Link, useNavigate} from "react-router-dom"

function Card(props) {
    const navigate = useNavigate();
    function redirect() {
        navigate(props.link)
    }
    return (
            <div className="card mx-2 my-4" key={props.id}>
                <img src={props.img} onClick={redirect} style={{height:300}} alt=""></img>
                <div className="card-body">
                        <h5 className="card-title">{props.name}</h5>
                    <p className="card-text">{props.desc}</p>
                    <Link to={props.link}><button className="btn btn-lg btn-primary">Haydi Başlayalım!</button></Link>
                </div>
            </div>
       
        
  )
}
export default memo(Card)
